import { useQuery } from "@tanstack/react-query";
import { OrderPaymentClient, OrderPaymentDto } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import type { OrderDrawerIdentifier } from "./types";

interface UseOrderPaymentDataOptions {
  identifier: OrderDrawerIdentifier | null;
  enabled: boolean;
}

export function useOrderPaymentData({
  identifier,
  enabled,
}: UseOrderPaymentDataOptions) {
  const api = useApi(OrderPaymentClient);

  const biOrderId = identifier?.biOrderId;
  const webOrderId = identifier?.webOrderId;
  const canFetch =
    enabled &&
    ((!!biOrderId && biOrderId > 0) || (!!webOrderId && webOrderId > 0));

  const query = useQuery({
    queryKey: ["order-drawer-payment", biOrderId ?? null, webOrderId ?? null],
    queryFn: async (): Promise<OrderPaymentDto | null> => {
      if (biOrderId && biOrderId > 0) {
        return api.getPaymentByBiOrderId(biOrderId);
      }
      if (webOrderId && webOrderId > 0) {
        return api.getPaymentByWebOrderId(webOrderId);
      }
      return null;
    },
    enabled: canFetch,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });

  return {
    paymentData: query.data ?? null,
    isLoading: query.isFetching,
    isError: query.isError,
  };
}
